import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  pageHeading: {
    id: "funding-application: get started heading",
    defaultMessage: "Get started",
  },
  pageSubtitle: {
    id: "funding-application: get started subtitle",
    defaultMessage: "Apply for funding and track your application progress.",
  },
  cardTitle: {
    id: "funding-application: get started application card title",
    defaultMessage: "Application",
  },
  tagActionRequired: {
    id: "funding-application: get started application card tag action required",
    defaultMessage: "Action required",
  },
  tagInReview: {
    id: "funding-application: get started application card tag in review",
    defaultMessage: "In review",
  },
  footerActionRequired: {
    id: "funding-application: get started application card footer action required",
    defaultMessage: "Complete these tasks to continue your review.",
  },
  footerInReview: {
    id: "funding-application: get started application card footer in review",
    defaultMessage: "We'll email you as soon as your review is complete.",
  },
  footerNoApplication: {
    id: "funding-application: get started application card footer no application",
    defaultMessage: "Apply for funding to power your next stage of growth.",
  },
  applyCta: {
    id: "funding-application: get started application card apply cta",
    defaultMessage: "Apply for funding",
  },
  emailVerificationTitle: {
    id: "funding-application: get started email verification title",
    defaultMessage: "Verify your email",
  },
  emailVerificationDescription: {
    id: "funding-application: get started email verification description",
    defaultMessage: "We've sent a verification link to {emailAddress}.",
  },
  emailVerificationSubtext: {
    id: "funding-application: get started email verification subtext",
    defaultMessage: "Avg. 1 min",
  },
  emailVerificationCta: {
    id: "funding-application: get started email verification cta",
    defaultMessage: "Resend email",
  },
  emailVerificationCtaSent: {
    id: "funding-application: get started email verification cta sent",
    defaultMessage: "Sent",
  },
  completedTag: {
    id: "funding-application: get started completed tag",
    defaultMessage: "Completed",
  },
});
